import React, { useEffect, useState } from 'react';
import { withdrawalsAPI } from '../../Api/withdrawals';
import api from '../../Api';
import {
  Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, CircularProgress, InputLabel, Select, FormControl
} from '@mui/material';

import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

export default function WithdrawalsList() {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [merchants, setMerchants] = useState([]);
  const [filters, setFilters] = useState({ merchant_id: '', startDate: '', endDate: '' });
  const [form, setForm] = useState({ amountRUB: '', rateBTC: '', rateUSDT: '', periodStart: '', periodEnd: '', btcTxId: '', merchant_id: '' });
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    fetchMerchants();
    fetchWithdrawals();
  }, []);

  const fetchMerchants = async () => {
    const res = await api.get('/merchants');
    setMerchants(res.data.data || res.data || []);
  };

  const fetchWithdrawals = async () => {
    setLoading(true);
    const res = await withdrawalsAPI.getAll(filters);
    setWithdrawals(res.data.data);
    setLoading(false);
  };

  const handleChange = e => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };


  const handleFormChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFilter = () => {
    fetchWithdrawals();
  };

  const handleAdd = async () => {
    setAdding(true);
    await withdrawalsAPI.create(form);
    setForm({ amountRUB: '', rateBTC: '', rateUSDT: '', period: '', btcTxId: '', merchant_id: '' });
    setOpen(false);
    fetchWithdrawals();
    setAdding(false);
  };

  return (
    <Box sx={{ p: { xs: 1, md: 4 }, maxWidth: 1100, mx: 'auto' }}>
      <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 700, color: '#683d62' }}>
        <MonetizationOnIcon sx={{ mr: 1, verticalAlign: 'middle' }} />Выплаты
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <FormControl sx={{ minWidth: 200 }} size="small">
          <InputLabel>Мерчант</InputLabel>
          <Select
            label="Мерчант"
            name="merchant_id"
            value={filters.merchant_id}
            onChange={handleChange}
          >
            <MenuItem value="">Все</MenuItem>
            {merchants.map(m => (
              <MenuItem key={m._id} value={m._id}>{m.name || m.email || m._id}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Дата с"
          name="startDate"
          type="date"
          value={filters.startDate}
          onChange={handleChange}
          size="small"
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="Дата по"
          name="endDate"
          type="date"
          value={filters.endDate}
          onChange={handleChange}
          size="small"
          InputLabelProps={{ shrink: true }}
        />
        <Button variant="outlined" onClick={handleFilter}>Фильтровать</Button>
        <Button variant="contained" color="primary" sx={{ ml: 'auto', bgcolor: '#683d62', '&:hover': { bgcolor: '#4d2e4a' } }} onClick={() => setOpen(true)}>
          Создать выплату
        </Button>
      </Box>
      <Paper sx={{ p: 2 }}>
        {loading ? <CircularProgress /> : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Мерчант</TableCell>
                  <TableCell>Сумма (₽)</TableCell>
                  <TableCell>Курс BTC</TableCell>
                  <TableCell>Курс USDT</TableCell>
                  <TableCell>Период</TableCell>
                  <TableCell>Дата создания</TableCell>
                  <TableCell>ID BTC транзакции</TableCell>
                  <TableCell>Подписана</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {withdrawals.map((w) => (
                  <TableRow key={w._id}>
                    <TableCell>{(merchants.find(m => m._id === w.merchant_id)?.name) || w.merchant_id}</TableCell>
                    <TableCell>{w.amountRUB}</TableCell>
                    <TableCell>{w.rateBTC}</TableCell>
                    <TableCell>{w.rateUSDT}</TableCell>
                    <TableCell>{w.period}</TableCell>
                    <TableCell>{new Date(w.createdAt).toLocaleString('ru-RU')}</TableCell>
                    <TableCell>{w.btcTxId}</TableCell>
                    <TableCell>{w.signed ? 'Да' : 'Нет'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Создать выплату</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <FormControl sx={{ minWidth: 200 }} size="small">
            <InputLabel>Мерчант</InputLabel>
            <Select
              label="Мерчант"
              name="merchant_id"
              value={form.merchant_id}
              onChange={handleFormChange}
              required
            >
              {merchants.map(m => (
                <MenuItem key={m._id} value={m._id}>{m.name || m.email || m._id}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField label="Сумма (₽)" name="amountRUB" value={form.amountRUB} onChange={handleFormChange} required type="number" />
          <TextField label="Курс BTC" name="rateBTC" value={form.rateBTC} onChange={handleFormChange} required type="number" />
          <TextField label="Курс USDT" name="rateUSDT" value={form.rateUSDT} onChange={handleFormChange} required type="number" />
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              margin="dense"
              label="Период с"
              name="periodStart"
              type="date"
              value={form.periodStart}
              onChange={handleFormChange}
              size="small"
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <TextField
              margin="dense"
              label="Период по"
              name="periodEnd"
              type="date"
              value={form.periodEnd}
              onChange={handleFormChange}
              size="small"
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Box>
          <TextField label="ID BTC транзакции" name="btcTxId" value={form.btcTxId} onChange={handleFormChange} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} disabled={adding}>Отмена</Button>
          <Button onClick={handleAdd} disabled={adding} variant="contained">Создать</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
